<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div class="uk-width-1-1">
      <div class="uk-align-right">
        <a href="#" @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
          <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
          Zurück
        </a>
      </div>
    </div>
    <div v-if="$can('manage', 'company') || $can('manage', 'all')">
      <ul uk-tab>
        <li><a href="#">Stammdaten</a></li>
        <li><a href="#">Benutzer</a></li>
      </ul>

      <ul class="uk-switcher uk-margin">
        <li>
          <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
            <div class="uk-card-body">
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <div class="uk-grid" uk-grid>
                  <!--
                  <div class="uk-width-1-1">
                    <div class="uk-text-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                    </svg>
                    Für Änderungen an Ihren Stammdaten, kontaktieren Sie uns bitte!
                    </div>
                  </div>-->
                  <div class="uk-width-1-2@l">
                    <div class="uk-grid" uk-grid>
                      <div class="uk-width-1-2@m">
                        <div class="uk-margin">
                          <label class="uk-form-label" for="company">Firma</label>
                          <div class="uk-form-controls">
                            <span class="uk-text-emphasis">{{ form.company }}</span>
                            <!--<input class="uk-input" id="company" name="company" type="text" v-model="form.company" />-->
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label" for="firstname">Vorname</label>
                          <div class="uk-form-controls">
                            <span class="uk-text-emphasis">{{ form.firstname }}</span>
                            <!--
                            <input
                              class="uk-input"
                              id="firstname"
                              name="firstname"
                              type="text"
                              v-model="form.firstname"
                            />
                            -->
                          </div>
                        </div>
                      </div>

                      <div class="uk-width-1-2@m">
                        <div class="uk-margin">
                          <label class="uk-form-label" for="ustid">USt.-Id.-Nr./VAT</label>
                          <div class="uk-form-controls"><span class="uk-text-emphasis" v-html="form.ustid || '&nbsp;'"></span>
                            <!--
                            <input class="uk-input" id="ustid" type="text" name="ustid" v-model="form.ustid" />
                            -->
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label" for="lastname">Nachname</label>
                          <div class="uk-form-controls"><span class="uk-text-emphasis">{{ form.lastname }}</span>
                            <!--
                            <input class="uk-input" id="lastname" type="text" name="lastname" v-model="form.lastname" />
                            -->
                          </div>
                        </div>
                      </div>

                      <div class="uk-width-1-1 uk-margin-top">
                        <div class="uk-margin">
                          <label class="uk-form-label" for="street">Straße</label>
                          <div class="uk-form-controls">
                            <span class="uk-text-emphasis">{{ form.street }}</span>
                            <!--
                            <input class="uk-input" id="street" type="text" name="street" v-model="form.street" />
                            -->
                          </div>
                        </div>
                      </div>

                      <div class="uk-width-1-2@m uk-margin-top">
                        <div class="uk-margin">
                          <label class="uk-form-label" for="zipcode">PLZ</label>
                          <div class="uk-form-controls">
                            <span class="uk-text-emphasis">{{ form.zipcode }}</span>
                            <!--
                            <input class="uk-input" id="zipcode" type="text" name="zipcode" v-model="form.zipcode" />
                            -->
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label" for="country">Land</label>
                          <div class="uk-form-controls">
                            <span class="uk-text-emphasis">{{ form.country }}</span>
                            <!--
                            <select class="uk-select" id="country" name="country" v-model="form.country">
                              <option value="Deutschland">Deutschland</option>
                            </select>
                            -->
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label" for="phone">Telefon</label>
                          <div class="uk-form-controls">
                            <input class="uk-input" id="phone" type="text" name="phone" v-model="form.phone" />
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label" for="fax">Fax</label>
                          <div class="uk-form-controls">
                            <input class="uk-input" id="fax" type="text" name="fax" v-model="form.fax" />
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label" for="mobile">Mobil</label>
                          <div class="uk-form-controls">
                            <input class="uk-input" id="mobile" type="text" name="mobile" v-model="form.mobile" />
                          </div>
                        </div>
                      </div>

                      <div class="uk-width-1-2@m uk-margin-top">
                        <div class="uk-margin">
                          <label class="uk-form-label" for="city">Ort</label>
                          <div class="uk-form-controls">
                            <span class="uk-text-emphasis">{{ form.city }}</span>
                            <!--
                            <input class="uk-input" id="city" type="text" name="city" v-model="form.city" />
                            -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="uk-width-1-2@l">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="email">E-Mail Adresse</label>
                      <div class="uk-form-controls">
                        <input class="uk-input" id="email" type="text" name="email" v-model="form.email" />
                      </div>
                    </div>
                    <!--
                    <p class="uk-margin">
                      Geben Sie das Passwort bitte nur ein, wenn Sie Ihr bisheriges Passwort ändern wollen. Das neue
                      Passwort muss mindestens 8 Zeichen lang sein.
                    </p>
                    <div class="uk-grid" uk-grid>
                      <div class="uk-width-1-2@m">
                        <label class="uk-form-label">Neues Passwort (min. 8 Zeichen)</label>
                        <div class="uk-form-controls">
                          <ValidationProvider :rules="'min:8'" name="password" v-slot="{ errors }">
                            <input
                              class="uk-input"
                              type="password"
                              name="password"
                              v-model="password"
                              :class="{ 'uk-form-danger': errors[0] }"
                            />
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="uk-width-1-2@m">
                        <label class="uk-form-label">Passwort wiederholen</label>
                        <div class="uk-form-controls">
                          <ValidationProvider
                            :rules="'min:8|confirmed:password'"
                            name="password_confirmation"
                            v-slot="{ errors }"
                          >
                            <input
                              class="uk-input"
                              type="password"
                              name="password_confirmation"
                              v-model="passwordConfirmation"
                              :class="{ 'uk-form-danger': errors[0] }"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    -->
                    <div class="uk-width-1-1 uk-margin-top">
                      <div class="uk-margin">
                        <label class="uk-form-label">Logo</label>
                        <div class="uk-margin-small-top">
                          <img
                            class="uk-height-max-small uk-margin"
                            v-if="logo"
                            :src="logo.path"
                            alt="Logo"
                          />
                        </div>
                      </div>
                      <upload
                        :url="uploadUrl"
                        :multiple="false"
                        name="logo"
                        :id="1"
                        type="logo"
                        @uploaded="logoAdded"
                      ></upload>
                    </div>
                  </div>
                  <div class="uk-width-1-1">
                    <div class="uk-align-right">
                      <button type="submit" class="uk-button uk-button-primary" @click.prevent="handleSubmit(store)">
                        Daten speichern
                      </button>
                    </div>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </li>
        <li>
          <Users :users="users" @created="onUserCreated" @deleted="onUserDeleted"></Users>
        </li>
      </ul>
    </div>
    <div v-else>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <div class="uk-grid" data-uk-grid>
              <div class="uk-width-1-1">
                <div class="uk-h3">Passwort ändern</div>
                <div class="uk-grid" uk-grid>
                  <div class="uk-width-1-2@m">
                    <label class="uk-form-label">Neues Passwort (min. 8 Zeichen)</label>
                    <div class="uk-form-controls">
                      <ValidationProvider :rules="'min:8'" name="password" v-slot="{ errors }">
                        <input
                          class="uk-input"
                          type="password"
                          name="password"
                          v-model="password"
                          :class="{ 'uk-form-danger': errors[0] }"
                        />
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="uk-width-1-2@m">
                    <label class="uk-form-label">Passwort wiederholen</label>
                    <div class="uk-form-controls">
                      <ValidationProvider
                        :rules="'required:password|min:8|confirmed:password'"
                        name="password_confirmation"
                        v-slot="{ errors }"
                      >
                        <input
                          class="uk-input"
                          type="password"
                          name="password_confirmation"
                          v-model="passwordConfirmation"
                          :class="{ 'uk-form-danger': errors[0] }"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <p class="uk-margin">
                  Das neue Passwort muss mindestens 8 Zeichen lang sein.
                </p>
              </div>
              <div class="uk-width-1-1" v-if="password">
                <div class="uk-align-right">
                  <button type="submit" class="uk-button uk-button-primary" @click.prevent="handleSubmit(store)">
                    Daten speichern
                  </button>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserService from '@/services/user.service'
import Upload from '@/components/Upload'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, confirmed, min } from 'vee-validate/dist/rules'
import Configuration from '@/configuration'
const uploadUrl = `${Configuration.value('apiFrontend')}/user/upload-logo`
const baseUrl = Configuration.value('apiUrl')
import { find } from 'lodash'
import Users from '@/components/Users'

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})

extend('confirmed', {
  ...confirmed
})

extend('min', {
  ...min
})

export default {
  data() {
    return {
      uploadUrl: uploadUrl,
      baseUrl: baseUrl,
      form: {
        company: '',
        firstname: '',
        lastname: '',
        ustid: '',
        street: '',
        zipcode: '',
        country: '',
        phone: '',
        fax: '',
        city: '',
        mobile: '',
        email: '',
        salutation: ''
      },
      password: '',
      passwordConfirmation: '',
      users: []
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Upload,
    Users
  },
  mounted() {
    this.get()
    this.getUsers()
  },
  computed: {
    logo() {
      return find(this.form.files, f => f.type === 'logo')
    }
  },
  methods: {
    async get() {
      const user = await UserService.me()
      this.form = user.data.merchant
    },
    async getUsers() {
      const users = await UserService.getList()
      this.users = users.data
    },
    async store() {
      await UserService.store(Object.assign({}, this.form, { password: this.password }))
      this.password = ''
      this.passwordConfirmation = ''
      iziToast.success({
        title: 'OK',
        message: 'Daten gespeichert!',
        timeout: 3000,
        position: 'topCenter'
      })
    },
    logoAdded() {
      iziToast.success({
        title: 'OK',
        message: 'Logo hochgeladen!',
        timeout: 3000,
        position: 'topCenter'
      })
      this.get()
    },
    onUserCreated() {
      this.getUsers()
    },
    onUserDeleted() {
      this.getUsers()
    }
  }
}
</script>
